(() => {
  const init = (root = document) => root.querySelectorAll('[data-kgm-arrival]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const enter = section.querySelector('[data-enter-maison]');
    const skip = section.querySelector('[data-skip-arrival]');
    const bar = section.querySelector('[data-arrival-loader-bar]');
    const canvas = section.querySelector('[data-arrival-particles]');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(() => { if (bar) bar.style.transform = 'scaleX(1)'; });
    setTimeout(() => section.classList.add('is-loaded'), reduce ? 80 : 1250);

    const go = () => {
      section.classList.add('is-entering');
      const rooms = document.getElementById('kgm-rooms');
      setTimeout(() => rooms?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }), reduce ? 10 : 760);
      setTimeout(() => section.classList.remove('is-entering'), 2100);
    };
    enter?.addEventListener('click', go);
    skip?.addEventListener('click', go);

    if (!canvas || reduce) return;
    const ctx = canvas.getContext('2d');
    let w = 0, h = 0, raf = 0;
    const particles = Array.from({length: 52}, () => ({x:Math.random(),y:Math.random(),r:Math.random()*1.6+.25,s:Math.random()*.00032+.00008,o:Math.random()*.45+.1}));
    const resize = () => { const d=Math.min(devicePixelRatio||1,2); w=canvas.clientWidth; h=canvas.clientHeight; canvas.width=w*d; canvas.height=h*d; ctx.setTransform(d,0,0,d,0,0); };
    const draw = () => { ctx.clearRect(0,0,w,h); for(const p of particles){p.y-=p.s*16;if(p.y<-.02){p.y=1.02;p.x=Math.random()}ctx.beginPath();ctx.arc(p.x*w,p.y*h,p.r,0,Math.PI*2);ctx.fillStyle=`rgba(222,196,143,${p.o})`;ctx.fill()} raf=requestAnimationFrame(draw); };
    resize(); draw(); addEventListener('resize',resize,{passive:true});
    document.addEventListener('shopify:section:unload', e => { if(e.target===section) cancelAnimationFrame(raf); });
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
